var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1747 0.825274C12.6427 0.292591 11.9343 0 11.1818 0C10.43 0 9.72164 0.292591 9.18964 0.825274L1.20341 8.81063C1.20341 8.81063 1.20271 8.81273 1.20131 8.81343C1.14461 8.87083 1.04801 9.02202 1.01861 9.13612L0.0211176 13.1288C-0.0390818 13.3668 0.0316176 13.6202 0.205216 13.7931L0.205916 13.7938L0.206616 13.7945C0.380215 13.9681 0.632212 14.0388 0.87091 13.9793L4.86368 12.9804C4.97778 12.951 5.12967 12.8544 5.18637 12.7977C5.18707 12.797 5.18917 12.7956 5.18917 12.7956L13.1754 4.81095C13.7074 4.27827 14.0007 3.57129 14 2.81811C14 2.06564 13.7074 1.35796 13.1754 0.825274H13.1747ZM8.68774 3.3095L10.6918 5.31354L4.69428 11.311L2.6902 9.30691L8.68774 3.3095ZM1.6626 12.3378L2.0791 10.6761L3.32509 11.9227L1.6626 12.3378ZM12.1863 1.81574C12.7211 2.35123 12.7211 3.285 12.1863 3.82048L11.683 4.32447L9.67684 2.31903L10.1815 1.81574C10.717 1.28096 11.6508 1.28026 12.1863 1.81574Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.d2e817bb9b57caa6b69ae3910a396793.svg";
export { ForwardRef as ReactComponent };